import _                                              from 'underscore';
import React, { FC, ReactNode }                       from 'react';
import { useField, useFormikContext }                 from 'formik';
import { FieldWrapper }                               from './FieldWrapper';
import { FieldDescription }                           from './FieldDescription';
import { DateInput, DateInputProps, DatesRangeInput } from 'semantic-ui-calendar-react';
import { TimeService }                                from '../../../../services';
import { FormikUseFieldType, SystemEvent }            from '../../../../types';


interface DateFieldProps {
    label?: ReactNode,
    descriptionText?: ReactNode,
    includeFieldWrapper?: boolean,
    includeErrorMessage?: boolean,
    ranged?: boolean,

    onAfterChange?( value: any, data: ( { prevValue: any } ), e: SystemEvent ): void,

    onAfterBlur?( value: any, data: ( { prevValue: any } ), e: SystemEvent ): void,

    [ additionalProps: string ]: any

}

// @ts-ignore
const defaultProps: DateFieldProps = {
    label:               null,
    descriptionText:     null,
    includeFieldWrapper: true,
    includeErrorMessage: true,
    ranged:              false,
    onAfterChange:       null,
    onAfterBlur:         null,
}

const DateField: FC<DateFieldProps> = ( _props ) => {

    let {
            label,
            ranged,
            descriptionText,
            includeFieldWrapper,
            includeErrorMessage,
            onAfterBlur,
            onAfterChange,
            ...props
        } = _props;

    // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
    // which we can spread on <input> and also replace ErrorMessage entirely.
    let formik = useFormikContext();

    const [ field, meta, helpers ] = ( formik ? useField( props as any ) : [ { name: props.name }, {}, {} ] ) as FormikUseFieldType;

    let showErrors  = ( meta.touched && meta.error ),
        Wrapper: FC = includeFieldWrapper ? FieldWrapper : React.Fragment;

    let componentProps = {

        ...field,

        onChange: async ( e: SystemEvent, v: any ) => {

            let prevValue = formik ? field.value : null;

            try{

                await helpers.setValue( v.value );

            } catch( e ) {

                // helpers not available
            }

            if( _.isFunction( onAfterChange ) ){ onAfterChange( v.value, { prevValue }, e ) }
        },
        onBlur:   async ( e: SystemEvent, v: any ) => {

            let prevValue = formik ? field.value : null;

            try{

                await helpers.setTouched( true );

            } catch( e ) {

                // helpers not available
            }

            if( _.isFunction( onAfterBlur ) ){ onAfterBlur( v.value, { prevValue }, e ) }
        },

        icon:         'calendar',
        iconPosition: ( _.isString( field.value ) && field.value.length > 0 ) ? "right" : "left",
        dateFormat:   TimeService.getDisplayDateFormat(),
        placeholder:  ranged ? `${ TimeService.getDisplayDateFormat() } - ${ TimeService.getDisplayDateFormat() }` : TimeService.getDisplayDateFormat(),
        duration:     0,
        animation:    '',
        clearable:    true,
        closable:     true,

        ..._.omit( props, 'onChange', 'onBlur' ),
    };

    return (

        <Wrapper { ...{ showErrors, includeErrorMessage, meta, field } }>


            { label && <label htmlFor={ props.id || props.name }>{ label }</label> }

            { descriptionText && <FieldDescription>{ descriptionText }</FieldDescription> }

            {/* https://github.com/arfedulov/semantic-ui-calendar-react */ }
            { ranged
              ? <DatesRangeInput { ...componentProps as DateInputProps } />
              : <DateInput startMode={ 'year' } { ...componentProps as DateInputProps } /> }

        </Wrapper>
    );
};

DateField.defaultProps = defaultProps;

export { DateField }
